// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"e24f47b6","107":"e5c28ba3","462":"1c6eafc9","569":"219d9900","704":"f4d3a81c","768":"0aa4eb1d","825":"87fb3242","877":"2409041f","919":"87cd8730","926":"a60d36d4","973":"c80c3306"}[chunkId] + ".chunk.js";
};